import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import { WidgetInput } from "react-addressfinder";
import "react-toastify/dist/ReactToastify.css";
import "react-addressfinder/dist/widget.css";
import { Rings } from "react-loader-spinner";


const SERVER_URL = process.env.REACT_APP_API_URL;

const PostPaidSimReplacement = () => {
    const navigate = useNavigate();
    const [onlyMobile, setOnlyMobile] = useState(true);
    const [mobileNumber, setMobileNumber] = useState('');
    const [isVerified, setIsVerified] = useState(false);

    const [customerName, setCustomerName] = useState('');
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [dob, setDob] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [simReplaceType, setSimReplaceType] = useState('');
    const [simNumber, setSimNumber] = useState('');
    const [simSelectOption, setsimSelectOption] = useState([]);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);



    const AddressFinderComponent = ({ addressFinderKey, inputClassName, id, onChange }) => {
        const handleSelectedAddress = (fullAddress) => {
            onChange(fullAddress);
            setDeliveryAddress(fullAddress);
        };

        return (
            <WidgetInput
                addressFinderKey={addressFinderKey}
                inputClassName={inputClassName}
                id={id}
                onSelected={handleSelectedAddress}
                placeholder="Enter Delivery Address"
                className="addressFinder-placeholder"
            />
        );
    };

    const handleVerify = async () => {
        try {
            const headers = await getApiHeader();
            const response = await axios.post(
                `${SERVER_URL}postpaid/sim-replacement-request/check`,
                { mobile_number: mobileNumber },
                { headers }
            );

            if (response.data.message === "Success") {
                setOnlyMobile(false);
                setIsVerified(true); 
                if (response.data.data.default_local_address) {
                    setDeliveryAddress(response.data.data.default_local_address)
                }

                if (response.data.data.sim_type === "Physical Sim") {
                    setsimSelectOption(['Physical Sim to Physical Sim', 'Physical Sim to ESIM']);
                } else if (response.data.data.sim_type === "eSIM") {
                    setsimSelectOption(['ESIM to Physical Sim', 'ESIM to ESIM']);
                }

                // swal("",response.data.message, 'error')
            } else {
                // swal("", response?.data?.message || 'Failed to send OTP.', 'error');

            }
        } catch (error) {
            if (error.response) {
                swal("", error?.response?.data?.message || 'An error occurred. Please try again.', 'error');
            } else {
                swal("",'An error occurred. Please try again.', 'error')
               
            }
        }
    };

    const handleTryAnotherNumber = () => {
        setMobileNumber('');
        setIsVerified(false);
        setOnlyMobile(true);
        setMobileNumber('');
        setCustomerName('');
        setDeliveryAddress('');
        setDob('');
        setEmailAddress('');
        setSimReplaceType('');
        setSimNumber('');
        setFile(null);
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (loading) return;

        setLoading(true);

        const formatDateOfBirth = (dob) => {
            const dateObj = new Date(dob);
            const day = String(dateObj.getDate()).padStart(2, '0');
            const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const year = dateObj.getFullYear();
            return `${day}/${month}/${year}`;
        };

        const formattedDob = formatDateOfBirth(dob);

        const formData = new FormData();
        formData.append('mobile_number', mobileNumber);
        formData.append('customer_name', customerName);
        formData.append('address', deliveryAddress);
        formData.append('date_of_birth', formattedDob);
        formData.append('email_address', emailAddress);
        formData.append('sim_replace_type', simReplaceType);
        formData.append('sim_number', simNumber);
        formData.append('id_document', file);

        try {
            const headers = await getApiHeader();
            const response = await axios.post(
                `${SERVER_URL}postpaid/sim-replacement-request/submit`,
                formData,
                { headers }
            );
            if (response.status === 200) {
                swal("","SIM Replacement request submitted successfully.", 'success')
                setMobileNumber('');
                setCustomerName('');
                setDeliveryAddress('');
                setDob('');
                setEmailAddress('');
                setSimReplaceType('');
                setSimNumber('');
                setFile(null);

                setOnlyMobile(true)


                setTimeout(() => {
                    window.location.reload();
                }, 3000)

            } else {
                swal("", response?.data?.message || ' Failed to submit request.', 'error');
            }
        } catch (error) {
            swal("", error?.response?.data?.message || 'An error occurred. Please try again.', 'error');


        }
        finally {
            setLoading(false);
        }
    };



    return (
        <DashboardLayout>
            <DashboardNavbar />



            <div className="formbold-main-wrapper container sim-replace row">
                <center>
                    <h5>  SIM Replacement Request</h5>
                    <div className="form-container">
                        {loading ? (
                            <div className="loader-container">
                                <Rings
                                    visible={true}
                                    height="500"
                                    width="80"
                                    color="#c11d6c"
                                    ariaLabel="rings-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                            </div>


                        ) : (
                            <form onSubmit={handleSubmit} encType="multipart/form-data"  autoComplete="off" >
                              
                              
                              
                                <div className="form-group add-plan-wrapper">
                                    <label htmlFor="mobile">Customer Mobile Number<span style={{ color: 'red' }}> *</span></label>
                                    <div className="input-container">
                                        <input
                                            type="tel"
                                            id="mobile"
                                            name="mobile"
                                            required
                                            pattern="[0-9]{10}"
                                            placeholder="Enter the mobile number"
                                            value={mobileNumber}
                                            onChange={(e) => setMobileNumber(e.target.value)}
                                            disabled={isVerified}
                                             className="sim-replacement-input-field"
                                             autoComplete="off"
                                        />
                                        <button
                                            type="button"
                                            className="input-button"
                                            onClick={handleVerify}
                                            disabled={isVerified}
                                        >
                                            Verify
                                        </button>
                                        {isVerified && (
                                            <button
                                                type="button"
                                                className="input-button"
                                                onClick={handleTryAnotherNumber}
                                            >
                                                Try Another Number
                                            </button>
                                        )}
                                    </div>
                                </div>


                                {!onlyMobile && (
                                    <>
                                        <div className="form-group">
                                            <label htmlFor="name">Customer Name<span style={{ color: 'red' }}> *</span></label>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                className="sim-replacement-input-field"
                                                placeholder="Enter Customer Name"
                                                value={customerName}
                                                autoComplete="new-password"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const filteredValue = value.replace(/[^a-zA-Z ]/g, "");
                                                    setCustomerName(filteredValue);
                                                }}
                                                required

                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="address">Select Address<span style={{ color: 'red' }}> *</span></label>
                                            {deliveryAddress ?
                                                <input
                                                    type="text"
                                                    className="input-text js-input sim-replacement-input-field"
                                                    name="delivery_address"
                                                    disabled
                                                    readOnly
                                                    value={deliveryAddress}
                                                    placeholder="Enter Delivery Address"
                                                    autoComplete="off"

                                                />
                                                :
                                                 <AddressFinderComponent
                                                    addressFinderKey="UJCFN4HL6YRMT3D9K8PG"
                                                    inputClassName="input-text js-input"
                                                    placeholder="Enter Delivery Address"
                                                    id="address"
                                                    onChange={setDeliveryAddress}
                                                    autoComplete="off"
                                                />
                                                
                                            }

                                                  
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="dob">Date of Birth<span style={{ color: 'red' }}> *</span></label>
                                            <input
                                                type="date"
                                                id="dob"
                                                name="dob"
                                                value={dob}
                                                onChange={(e) => setDob(e.target.value)}
                                                required
                                                className="sim-replacement-input-field"
                                                autoComplete="off"
                                                max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split("T")[0]}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="email">Email Address<span style={{ color: 'red' }}> *</span></label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                placeholder="Enter Email Address"
                                                style={{ fontSize: "20px" }}
                                                value={emailAddress}
                                                onChange={(e) => setEmailAddress(e.target.value)}
                                                required
                                                className="sim-replacement-input-field"
                                                autoComplete="off"

                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="sim">SIM Replace Type <span style={{ color: 'red' }}> *</span></label>
                                            <select
                                                id="sim"
                                                name="sim"
                                                value={simReplaceType}
                                                onChange={(e) => setSimReplaceType(e.target.value)}
                                                required
                                                className="sim-replacement-input-field"
                                            >
                                                    <option value="" disabled selected style={{ fontSize: "10px", color: "gray" }}>
                                                        Select SIM Replace Type
                                                    </option>
                                                {simSelectOption.map((option, index) => (
                                                    <option key={index} value={option}>
                                                        {option}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        {(simReplaceType === "ESIM to Physical Sim" || simReplaceType === "Physical Sim to Physical Sim") && (
                                            <div className="form-group">
                                                <label htmlFor="sim-number">SIM Number <span style={{ color: 'red' }}> *</span> </label>
                                                <input
                                                    type="text"
                                                    id="sim-number"
                                                    name="sim-number"
                                                    placeholder="Enter SIM Number"
                                                    className="sim-replacement-input-field"
                                                    value={simNumber}
                                                    autoComplete="off"
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const numericValue = value.replace(/[^0-9]/g, '');
                                                        setSimNumber(numericValue);
                                                    }}
                                                    required
                                                />


                                            </div>
                                        )}
                                        <div className="form-group">
                                            <label htmlFor="file-upload">Upload ID Validation Document<span style={{ color: 'red' }}> *</span></label>
                                            <input
                                                type="file"
                                                id="file-upload"
                                                name="file-upload"
                                                accept=".pdf, .jpg, .jpeg"
                                                onChange={(e) => setFile(e.target.files[0])}
                                                required
                                                className="sim-replacement-input-field form-control form-control-lg"
                                                autoComplete="off"
                                                
                                            />
                                            <b style={{ display: 'block', fontSize:'14px', textAlign: 'left' }}>
                                                Accept: .pdf, .jpg, .jpeg, Max file size 2MB.
                                            </b>
                                        </div>
                                        <input type="submit" value="Proceed" disabled={loading} />
                                    </>
                                )}
                            </form>
                        )}
                    </div>
                </center>
            </div>


        </DashboardLayout>
    );
};

export default PostPaidSimReplacement;
